export const GET_FILING_STATUS_SUCCESS = 'GET_FILING_STATUS_SUCCESS';
export const GET_FILING_STATUS_FAILURE = 'GET_FILING_STATUS_FAILURE';
export const ADD_SELECTED_FILING_STATUS = 'ADD_SELECTED_FILING_STATUS';
export const REMOVE_ALL_FILING_STATUS = 'REMOVE_ALL_FILING_STATUS';
